import AuthFormForgottenPasswordReconf from "../../components/Auth/AuthFormForgottenPasswordReconf";
import TemplateAuthentication from "../../components/UI/TemplateAuthentication";
import AuthHeader from "../../components/Auth/AuthHeader.tsx";

interface ForgottenPasswordReconfProps {
  isInvite?: boolean;
}

export default function ForgottenPasswordReconf({
  isInvite,
}: ForgottenPasswordReconfProps) {
  return (
    <TemplateAuthentication>
      <AuthHeader
        title={
          isInvite
            ? "Créez votre mot de passe"
            : "Réinitialisez votre mot de passe"
        }
      />
      <AuthFormForgottenPasswordReconf />
    </TemplateAuthentication>
  );
}
